import { getFormInput } from '@/utils/form-input-helper';
import { SelfServiceService } from '@/services/store/self-service-service';
import { IPdsDocumentResponse } from '@/interfaces/entities/pds-document-response.interface';
import { PetCoverage, ResidentialCoverage, VehicleCoverage } from '@/interfaces';
import { HOME_PAGE } from '@/constants/urls.const';

export const policyDetailsCheckIcon = `<span class='bg-icon-success icon w-3 h-3 bg-no-repeat bg-contain inline-block mr-2'></span>`;

export function getAdditionalText(content: any, formInputId: string): string {
  return getFormInput(content, formInputId)?.label?.value?.replaceAll('"', "'") ?? '';
}

export async function getPdsOrSpdsResponse(version: string): Promise<IPdsDocumentResponse | null> {
  try {
    const pdsDocumentResponse = await SelfServiceService.getPdsOrSpdsUrl(version);
    return pdsDocumentResponse;
  } catch (error) {
    return null;
  }
}

export enum InsuranceDocumentType {
  PDS = 'PDS',
  SPDS = 'SPDS',
}

export async function getPdsOrSpdsVersion(
  coverage: VehicleCoverage | ResidentialCoverage | PetCoverage,
  insuranceDocumentType: InsuranceDocumentType
) {
  let version = '';
  if (insuranceDocumentType === InsuranceDocumentType.PDS) {
    if (!coverage.pdsVersion) {
      return 'Not applicable';
    }
    version = coverage.pdsVersion;
  } else {
    if (!coverage.spdsVersion) {
      return 'Not applicable';
    }
    version = coverage.spdsVersion;
  }

  const response = await getPdsOrSpdsResponse(version);
  if (response === null || response.link.length === 0 || response.title.length === 0) {
    return 'Not applicable';
  }

  const anchorTagFromFormInputs =
    `<a href="${HOME_PAGE}${response.link}" target="_blank">View ${insuranceDocumentType}</a>`.replaceAll('"', "'");
  return `${response.title} ${version}<br/>${anchorTagFromFormInputs}`;
}
